const TOKEN_KEY = 'beaulon_admin_token';
const ADMIN_KEY = 'beaulon_admin_user';

export function saveAuth(token, admin) {
  localStorage.setItem(TOKEN_KEY, token);
  if (admin) localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getAdmin() {
  try {
    return JSON.parse(localStorage.getItem(ADMIN_KEY) || 'null');
  } catch { return null; }
}

export function isAuthenticated() {
  return Boolean(getToken());
}
